import React, { useState } from 'react';
import { Input, Button, Card, message,  Space,  Row, Col } from 'antd';
import { DownloadOutlined, MergeOutlined } from '@ant-design/icons';
import api from '../api/axios';

export default function Merge_PDF() {
    const [invoiceNumbers, setInvoiceNumbers] = useState('');
    const [loading, setLoading] = useState(false);
    const [merging, setMerging] = useState(false);

    // Parse comma-separated invoice numbers
    const parseInvoiceNumbers = (input) => {
        return input
            .split(',')
            .map(num => num.trim())
            .filter(num => num.length > 0);
    };

    const handleMergeAndDownload = async () => {
        const invoices = parseInvoiceNumbers(invoiceNumbers);

        if (invoices.length === 0) {
            message.error('Please enter at least one invoice number');
            return;
        }

        setMerging(true);
        try {
            const response = await api.post(
                '/invoices/purchase/merge-pdf',
                { invoiceNumbers: invoices },
                { responseType: 'blob' }
            );

            // Create download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `merged_invoices_${Date.now()}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            message.success(`Successfully merged ${invoices.length} invoice(s)`);
            setInvoiceNumbers(''); // Clear input
        } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || 'Failed to merge PDFs';
            message.error(errorMsg);
        } finally {
            setMerging(false);
        }
    };

    return (
        <div style={{ padding: 24 }}>
            <Card
                title="Merge Purchase Invoice PDFs"
                style={{ maxWidth: 600, margin: '0 auto' }}
            >
                <Space direction="vertical" style={{ width: '100%' }} size="large">

                    <div>
                        <label style={{ fontWeight: 500, marginBottom: 8, display: 'block' }}>
                            InvoiceID (comma-separated)
                        </label>
                        <Input.TextArea
                            rows={4}
                            placeholder="Example: 1001, 1002, 1003"
                            value={invoiceNumbers}
                            onChange={(e) => setInvoiceNumbers(e.target.value)}
                            disabled={merging}
                        />
                        <small style={{ color: '#999', marginTop: 4, display: 'block' }}>
                            Enter InvoiceID separated by commas. Example: 1001, 1002, 1003
                        </small>
                    </div>

                    {invoiceNumbers && (
                        <div style={{
                            padding: 8,
                            background: '#e6f7ff',
                            borderRadius: 4,
                            fontSize: 12
                        }}>
                            <strong>Invoices to merge:</strong> {parseInvoiceNumbers(invoiceNumbers).length}
                            <br />
                            {parseInvoiceNumbers(invoiceNumbers).map((inv, idx) => (
                                <span key={idx} style={{ marginRight: 8 }}>
                  <code>{inv}</code>{idx < parseInvoiceNumbers(invoiceNumbers).length - 1 && ', '}
                </span>
                            ))}
                        </div>
                    )}

                    <Row gutter={16}>
                        <Col span={12}>
                            <Button
                                type="primary"
                                icon={<MergeOutlined />}
                                onClick={handleMergeAndDownload}
                                loading={merging}
                                disabled={invoiceNumbers.trim().length === 0}
                                block
                            >
                                {merging ? 'Merging...' : 'Merge & Download'}
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Button
                                onClick={() => setInvoiceNumbers('')}
                                disabled={merging}
                                block
                            >
                                Clear
                            </Button>
                        </Col>
                    </Row>

                    <div style={{
                        padding: 12,
                        background: '#f9f9f9',
                        borderRadius: 4,
                        fontSize: 12,
                        color: '#666'
                    }}>
                        <strong>ℹ️ How it works:</strong>
                        <ul style={{ margin: '8px 0', paddingLeft: 20 }}>
                            <li>Enter one or more invoice numbers separated by commas</li>
                            <li>Click "Merge & Download" to combine all PDFs into one file</li>
                            <li>The merged PDF will be downloaded to your computer</li>
                        </ul>
                    </div>
                </Space>
            </Card>
        </div>
    );
}
